import * as Aria from "react-aria-components"
import styled from "styled-components"

interface ToggleButtonProps {
  onToggle?: (active: boolean) => void
  active?: boolean
  disabled?: boolean
}

const IndicatorStyle = styled.div`
  width: 28px;
  height: 28px;
  position: absolute;
  top: -2px;

  background: linear-gradient(180deg, #595959 0%, #454545 100%);
  box-shadow: 0px 2px 6px rgba(119, 119, 119, 0.25);
  border-radius: 9999px;

  transition-property: transform;
  transition-duration: 0.2s;
  transition-timing-function: ease-out;
`

const ToggleButtonStyle = styled(Aria.Switch)`
  display: block;
  width: 52px;
  height: 24px;
  position: relative;

  cursor: pointer;

  background: #c3c3c3;
  box-shadow: 0px 2px 5px rgba(37.19, 37.19, 37.19, 0.25) inset;
  border-radius: 20px;

  &::before {
    content: "";
    position: absolute;
    border-radius: 20px;
    box-shadow: 0px 2px 5px rgba(37.19, 37.19, 37.19, 0.25) inset;
    background: linear-gradient(97deg, #81a6c8 0%, #97d1d9 100%);
    inset: 0;
    opacity: 0;

    transition-property: opacity;
    transition-duration: 0.2s;
    transition-timing-function: ease-out;
  }

  &[data-selected]::before {
    opacity: 1;
  }

  &[data-disabled],
  &[data-disabled]::before {
    cursor: auto;
    transition: none;
    background: #fafafa;
  }

  &[data-disabled] ${IndicatorStyle} {
    background: #c3c3c3;
  }

  & ${IndicatorStyle} {
    transform: translateX(0);
  }

  &[data-selected] ${IndicatorStyle} {
    transform: translateX(calc(100% - 4px));
  }
`

const ToggleButton: React.FC<ToggleButtonProps> = ({ onToggle, active, disabled = false }) => {
  return (
    <ToggleButtonStyle isSelected={active} isDisabled={disabled} onChange={onToggle}>
      <IndicatorStyle />
    </ToggleButtonStyle>
  )
}

export default ToggleButton
